export interface AboutData {
    title: string;
    limit_date: string;
    description: string;
}

export const AboutData: AboutData[] = [
    {
        title: "DMM Sprint 2026 Goコース",
        limit_date: "2026/08/03 ~ 2026/08/07",
        description:
            "DMM株式会社の短期インターンに参加<br />Go言語・オニオンアーキテクチャ・DDDを学び、SNSアプリ「Yatter」をチーム開発",
    },
    {
        title: "株式会社サイバーエージェント（1dayインターン）",
        limit_date: "2026/06/27",
        description: "マルチテナントなシステムを設計",
    },
    {
        title: "Crosshare株式会社",
        limit_date: "2024/04 ~ 2024/12",
        description:
            "焼肉店Webサイトの制作。デザインからフロントエンド実装まで担当<br />React、TypeScript、Tailwind CSSを使用",
    },
    {
        title: "Pactom株式会社",
        limit_date: "2025/08 ~ 2025/09",
        description:
            "設計書をもとにしたUI実装を担当<br />React、TypeScript、Tailwind CSSを使用",
    },
    {
        title: "startgeer株式会社",
        limit_date: "2025/10 ~ 現在",
        description:
            "自社システムの開発・改修、UIライブラリ開発などに従事<br />フロントエンドを中心にフルスタックで担当",
    },
    {
        title: "ひろぎんナレッジスクエア株式会社",
        limit_date: "2023/12 ~ 2025/11",
        description: "主に小中高生にスクラッチ、html、css、jsを指導",
    },
];  